import { describe, it, expect } from 'vitest';

describe('@memberjunction/ng-container-directives', () => {
  it('should have a passing test', () => {
    expect(true).toBe(true);
  });
});
